import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ClientDashboardPage = lazy(() => import('@/pages/dashboard/client'));

/**
 * Client-portal dashboard route. Uses the same shell (header/sidebar) as every other route —
 * a ClientUser simply has no permission for anything else, so the existing permission-filtered
 * navigation naturally leaves them with just this one page. Enforcement that they can't reach
 * anything else lives server-side (clientPortalGuard) and in AccessProvider's route redirect,
 * not in the layout.
 */
export const clientDashboardRoutes: RouteConfig = {
  path: '/dashboard/client',
  element: ClientDashboardPage,
  layout: DashboardLayout,
};
